import React, { useContext } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";
import headerStyles from "../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import styles from "../../../assets/styles/componentStyles/customApiStyles/customApiStyle.module.scss";
import { Divider, Grid, useMediaQuery } from '@mui/material';
import GlobalPageHeaderText from '../../utility/globalPageHeaderText';
import ConfiguredWebhookTable from './configuredWebhookTable';
import AvailableWebhookTable from './availableWebhookTable';
import { useWebhookStore } from '../../../store/webhookStore';
import { UserContext, UserContextPayload } from '../../../context/userContext';


const WebhookGlobal = () => {

    const breakPoints = {
        smallScreen: useMediaQuery('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery('(max-width : 900px) and (min-width : 600px)'),
    } 

    const innerHeight = window.innerHeight - 100;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload

    const getWebhookOrganizationList = useWebhookStore((state) => state.getWebhookOrganizationList);

    const getWebhookOrganizationListApi = async () => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        const res = await getWebhookOrganizationList(); 
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    }
    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`}>
                <Grid container className={globalStyles.headerGlobalPaddingStyle} direction={"column"} flexWrap={"nowrap"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container alignItems={"center"} direction={"column"}>
                            <Grid item className={`${globalStyles.fullwidth} ${styles.webhookContainerStyles}`}>
                                <GlobalPageHeaderText
                                    mainHeadText="Webhook"
                                    flagMainTextOnly
                                /> 
                                {!(breakPoints.smallScreen) && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle} ${styles.customAPIPageDivider} ${styles.customAPIPageDividerWebhook}`} />}
                            </Grid>
                        </Grid>
                    </Grid> 

                    <Grid item xs={12} sm={12} className={styles.webhookItemStyles} sx={{ maxHeight: `${innerHeight}px !important` }}>
                        <Grid container gap={5}>
                            <Grid item xs={12}>
                                <ConfiguredWebhookTable
                                    getWebhookOrganizationListApi={getWebhookOrganizationListApi}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <AvailableWebhookTable
                                    getWebhookOrganizationListApi={getWebhookOrganizationListApi}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default WebhookGlobal
